module.exports = __webpack_public_path__ + "img/ic_star.8260d71f.png";